import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
    Outlet
} from "react-router-dom";
import AlunoTransporte from './pages/Aluno/editarOrganizacao'
import EditarAluno from './pages/Aluno/EditarIdenticacao';
import EditarAlunoForm2 from './pages/Aluno/EditarDadosPessoais';
import Home from "./pages/Home";
import EditarGestor from './pages/Gestor/EditarIdentificacao'
import EditarGestorForm2 from './pages/Gestor/EditarDadosPessoais'
import PesquisarGestor from './pages/Gestor/pesquisar';
import EditarEscolaIdentificacao from './pages/Escola/EditarIdentificacao'
import EditarForm2Escola from './pages/Escola/EditarCaracterizacao'
import EditarForm3Escola from './pages/Escola/EditarOrganizacao'
import PesquisarTurma from "./pages/Turma/Pesquisar";
import PesquisarAluno from "./pages/Aluno/PesquisarAluno";
import PesquisarProfissionalEscolar from "./pages/ProfissionalEscolar/Pesquisar";
import EditarProfissional from './pages/ProfissionalEscolar/EditarIdentificacao';
import EditarProfissionalForm2 from './pages/ProfissionalEscolar/EditarDadosPessoais'
import Login from './pages/login/index'
import Vincular from './pages/Turma/Vincular'
import EditarTurma from './pages/Turma/Editar'
import { useContext } from "react";
import { authContext } from "./context/auth";

function PrivateRoute({ element: Element, ...rest }) {
    const { auth, isLoading } = useContext(authContext);

    if (isLoading) return <Outlet />;

    return auth ? <Outlet /> : <Navigate to="/login" />;

};


function Routers() {
    const { auth } = useContext(authContext)

    return (
        <BrowserRouter>
            <Routes>
                <Route path='/Home' element={<PrivateRoute />}>
                    <Route path='/Home' element={<Home />} />
                </Route>
                <Route path='/aluno/editar-identificacao' element={<PrivateRoute />}>
                    <Route element={<EditarAluno />} path='/aluno/editar-identificacao' />
                </Route>
                <Route path='/aluno/editar-dados-pessoais' element={<PrivateRoute />}>
                    <Route element={<EditarAlunoForm2 />} path='/aluno/editar-dados-pessoais' />
                </Route>
                <Route path='/aluno/editar-organizacao' element={<PrivateRoute />}>
                    <Route element={<AlunoTransporte />} path='/aluno/editar-organizacao' />
                </Route>
                <Route path='/aluno/pesquisar' element={<PrivateRoute />}>
                    <Route element={<PesquisarAluno />} path='/aluno/pesquisar' />
                </Route>
                <Route path='/gestor/pesquisar' element={<PrivateRoute />}>
                    <Route element={<PesquisarGestor />} path='/gestor/pesquisar' />
                </Route>
                <Route path='/gestor/editar-identificacao' element={<PrivateRoute />}>
                    <Route element={<EditarGestor />} path='/gestor/editar-identificacao' />
                </Route>
                <Route path='/gestor/editar-dados-pessoais' element={<PrivateRoute />}>
                    <Route element={<EditarGestorForm2 />} path='/gestor/editar-dados-pessoais' />
                </Route>
                <Route path='/profissional/pesquisar' element={<PrivateRoute />}>
                    <Route element={<PesquisarProfissionalEscolar />} path='/profissional/pesquisar' />
                </Route>
                <Route path='/profissional/editar-identificacao' element={<PrivateRoute />}>
                    <Route element={<EditarProfissional />} path='/profissional/editar-identificacao' />
                </Route>
                <Route path='/profissional/editar-dados-pessoais' element={<PrivateRoute />}>
                    <Route element={<EditarProfissionalForm2 />} path='/profissional/editar-dados-pessoais' />
                </Route>
                <Route path='/escola/editar-identificacao' element={<PrivateRoute />}>
                    <Route element={<EditarEscolaIdentificacao />} path='/escola/editar-identificacao' />
                </Route>
                <Route path='/escola/editar-caracterizacao' element={<PrivateRoute />}>
                    <Route element={<EditarForm2Escola />} path='/escola/editar-caracterizacao' />
                </Route>
                <Route path='/escola/editar-organizacao' element={<PrivateRoute />}>
                    <Route element={<EditarForm3Escola />} path='/escola/editar-organizacao' />
                </Route>
                <Route path='/turma/pesquisar' element={<PrivateRoute />}>
                    <Route element={<PesquisarTurma />} path='/turma/pesquisar' />
                </Route>
                <Route path='/turma/vincular' element={<PrivateRoute />}>
                    <Route element={<Vincular />} path='/turma/vincular' />
                </Route>
                <Route path='/turma/editar' element={<PrivateRoute />}>
                    <Route element={<EditarTurma />} path='/turma/editar' />
                </Route>
                <Route element={auth ? <Home /> : <Login />} path='/' />
                <Route path='*' element={auth ? <Outlet replace /> : <Login />} />
            </Routes>
        </BrowserRouter>
    )
}
export default Routers;